import { Card } from "antd";
import styled from "styled-components";

export const StyledCard = styled(Card)`
  height: 90px;
  width: 360px;
  max-width: 100%;
  margin-bottom: 1em;
  overflow: hidden;
  .ant-card-body {
    padding: 0;
  }
`;

export const StyledImg = styled.img`
  height: 90px;
  width: 100%;
  object-fit: cover;
  border-radius: var(--border-radius) 0px 0px var(--border-radius);
`;
